export const themeData = [
  {
    id: 1,
    value: 'default',
    color: '#409EFF',
    name: '默认'
  },
  {
    id: 2,
    value: 'theme-orange',
    color: '#FF903D',
    name: '橙色'
  },
  {
    id: 3,
    value: 'theme-green',
    color: '#0ABE8C',
    name: '绿色'
  },
  {
    id: 4,
    value: 'theme-red',
    color: '#E83F3E',
    name: '红色'
  },
  {
    id: 5,
    value: 'theme-purple',
    color: '#5D6EFD',
    name: '紫色'
  }
]
